import React, {FC} from 'react';

import {KnowledgeBasePluginPanelId} from '../../../libs/shared/core/src/store/panels/panelStateBase';
import {Frame} from '../common/frames/frame';
import {KnowledgeBasePopupPluginContainer} from '../knowledgeBasePlugin/knowledgeBasePopupPluginContainer';

/*
 * Props.
 */

interface PopupKnowledgeBasePluginProps {
  panelId: KnowledgeBasePluginPanelId;
  onRequestClose: () => void;
  popupWidth?: number;
}

/*
 * Component.
 */

export const PopupKnowledgeBasePlugin: FC<PopupKnowledgeBasePluginProps> = (props) => {
  const {panelId, popupWidth, onRequestClose} = props;
  return (
    <Frame
      minWidth="270px"
      width={popupWidth ?? 300}
      height={700}
      shouldForcePopout
      onRequestClose={onRequestClose}
      startHeight={undefined}
      interactionId="popup-knowledge-base"
    >
      <KnowledgeBasePopupPluginContainer panelId={panelId} onClose={onRequestClose} />
    </Frame>
  );
};
